import SubscriptionPage from './components/SubscriptionPage';

const routes = [
  {
    path: '/subscription/:page?',
    name: 'menu.subscription',
    icon: 'ticket',
    customIcon: false,
    loginRequired: true,
    component: SubscriptionPage,
    weight: 101,
    permission: ['frontend_menu_subscriptions'],
    children: [],
  },
];

export default routes;
